<template>
    <div>
        <div class="ckeditor"><textarea :id="id" :value="value"></textarea></div>

        <div v-if="tags && tags.length > 0" class="ba-grid ba-w-100 ba-gp-08 mt-2">
            <span class="ba-montserrat-700 ba-text-14">{{ $t('ct-available-tags')}}:</span>
            <div class="ba-w-100">
              <span class="badge badge-primary mx-1 px-2 py-1" v-for="(tag, index) in tags" @click.prevent="insertTag(tag)"
              v-tooltip="{content: $t(`ct-${tag.label}`),  class: 'tooltip-custom'}" :key="index" style="cursor:pointer"> {{tag.tag}}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'CKEditor',
  props: {
    value: {
      type: String
    },
    id: {
      type: String,
      default: 'editor'
    },
    height: {
      type: String,
      default: '250px'
    },
    toolbar: {
      type: Array,
      default: () => [
        ['Undo', 'Redo'],
        ['Bold', 'Italic', 'Strike'],
        ['NumberedList', 'BulletedList'],
        ['Cut', 'Copy', 'Paste']
      ]
    },
    language: {
      type: String,
      default: 'en'
    },
    extraplugins: {
      type: String,
      default: ''
    },
    removePlugins: {
      type: String,
      default: 'elementspath'
    },
    resize_enabled: {
      type: Boolean,
      default: false
    },
    fullPage: {
      type: Boolean,
      default: true
    },
    allowedContent: {
      type: Boolean,
      default: true
    },
    extraAllowedContent: {
      type: String,
      default: '*'
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      editor: ''
    };
  },
  methods: {
    insertTag(tag) {
      var html = '<span>' + tag.tag + '</span>';

      if (tag.selector === 'div') { html = '<div>' + tag.tag + '</div>' };

      var newElement = CKEDITOR.dom.element.createFromHtml(html, this.editor.document);
      this.editor.insertElement(newElement);
    }
  },
  beforeUpdate() {
    // const ckeditorId = this.id;
    // if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
    //   CKEDITOR.instances[ckeditorId].setData(this.value);
    // }
  },
  mounted() {
    const ckeditorId = this.id;

    const ckeditorConfig = {
      toolbar: this.toolbar,
      language: this.language,
      height: this.height,
      extraPlugins: this.extraplugins,
      removePlugins: this.removePlugins,
      resize_enabled: this.resize_enabled,
      fullPage: this.fullPage,
      allowedContent: this.allowedContent,
      extraAllowedContent: this.extraAllowedContent
    };

    this.editor = CKEDITOR.replace(ckeditorId, ckeditorConfig);
    CKEDITOR.instances[ckeditorId].setData(this.value);
    CKEDITOR.instances[ckeditorId].on('change', () => {
      let ckeditorData = CKEDITOR.instances[ckeditorId].getData();

      if (ckeditorData !== this.value) {
        this.$emit('input', ckeditorData);
      }
    });
  },
  destroyed() {
    const ckeditorId = this.id;
    if (CKEDITOR.instances[ckeditorId]) {
      CKEDITOR.instances[ckeditorId].destroy();
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/CKEditor.vue